<script setup>
import SearchBox from "../components/SearchBox.vue";
import { useUtilityStore } from "../store/UtililityStore";
import { useProductStore } from "../store/ProductStore";
import productBox1 from "./product-box/product-box1.vue";
import { useWindowScroll } from "@vueuse/core";
import { ref, onMounted } from "vue";
import { OnClickOutside } from "@vueuse/components/index";

const router = useRouter();
const props = defineProps(["range"]);
const utilityStore = useUtilityStore();
const productStore = useProductStore();

const { y } = useWindowScroll({ behavior: 'smooth' });
// const selectedLanguage = computed(() => utilityStore.selectedLanguage);
const backOrders = computed(() => productStore.backOrders);
const miniProducts = computed(() => productStore.miniSearchProducts);
const miniPending = computed(() => productStore.miniSearchPending);
const selectedLanguage = computed(() => utilityStore.selectedLanguage);

const filterInput = ref("");

const fetchTimeoutId = ref();
const { range } = toRefs(props);
const startRowIndex = ref(1);
const localePath = useLocalePath();

const state = reactive({
  loadingCart: {},
  selectedSort: [
    // {
    //   Created: {
    //     order: "desc",
    //   },
    // },
    // {
    //   Updated: {
    //     order: "desc",
    //   },
    // },
  ],
});
// const { data: productsWithAgg, pending, error: pError, exec } =
//   useLatestFetch(() => `${useURLs[NODE_ENV].PRODUCT_SEARCH_URL}?ctx=use-ctr`)
// const products = computed(() => productsWithAgg.value?.products || []);

// const executionCB = async (ctx) => {

//   await exec({
//     pick: [
//       "products",
//     ],
//     body: {
//       sortOrder: state.selectedSort,
//       prefix: filterInput.value,
//       range: range.value,
//       startRowIndex: startRowIndex.value,
//       filters: {},
//       selectedLanguage: selectedLanguage.value,

//     },
//     params: { ctx },
//     method: 'POST'
//   })
// }

const handleInput = (value) => {

  clearTimeout(fetchTimeoutId.value);
  filterInput.value = value;

  // executionCB('keyword-change-hm');
  fetchTimeoutId.value = setTimeout(() => {
    productStore.fetchMiniSearchProducts({
      prefix: filterInput.value,
      selectedLanguage: selectedLanguage.value,
      range: 10,
      startRowIndex: 1,
    });
  }, 250);


};
const offHandlerInput = EventBus.on("searchSelect", handleInput);

const goToSearchResults = (event) => {
  event && event.preventDefault();
  router.push({
    path: localePath("/products/search"),
    query: {
      ...{
        ...(filterInput.value && { ...{ q: filterInput.value } }),
      },
    },
  });
};
const close = () => {
  // keep this component isolated: clear only mini-search results
  productStore.clearMiniSearchProducts();
};

const offGoToSearchResults = EventBus.on("goto-Search", goToSearchResults);

// onBeforeUnmount(() => {
//   productStore.resetProducts();
//   filterInput.value = "";
// });
// onMounted(() => {
//   productStore.resetProducts();
//   filterInput.value = "";
// });
onBeforeUnmount(() => {

  clearTimeout(fetchTimeoutId.value);
  offGoToSearchResults();
  offHandlerInput();
  productStore.clearMiniSearchProducts();
});


// watchDebounced(pending, () => {

//   if (!pending.value && filterInput.value === "") {
//     products.value = [];
//     productsWithAgg.value = null;
//   }

// }, { debounce: 2000 });
</script>

<template>
  <div class="mini-search-container container bg-white rounded-lg  " :class="{ position: y > 100 && y <= 600, smalls: y > 600 }">
    <OnClickOutside @trigger="close">
      <div class="mini-search" :class="{ position: y > 100 && y <= 600, smalls: y > 600 }">
        <SearchBox key="cld-search" @searchSelect="handleInput" :input="filterInput"
          @keydown.enter="goToSearchResults" />
      </div>
    </OnClickOutside>
  </div>
  <div id="content" class="">
    <div v-if="miniPending">
      <WidgetsLoader :loading="miniPending"> </WidgetsLoader>
    </div>
    <div id="products" v-else>
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 justify-items-center max-w-[1440px] mx-auto px-4"
        v-if="miniProducts && miniProducts.length">
        <div v-for="(item, i) in miniProducts" :key="i" class="w-full flex justify-center">
          <div class="w-full max-w-[250px]">
            <productBox1 :item="item" :index="i" :backOrders="backOrders" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
/* Scoped styles for product-box removed as they are now centralized */

/* @media (max-width: 767.5px) {
  #filterbar {
    width: 50%;
  }
}

@media (max-width: 525.5px) {
  #filterbar {
    float: none;
    width: 100%;
    margin-bottom: 20px;
    border-radius: 5px;
  }

  #content.my-5 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }

  .col-lg-4,
  .col-md-6 {
    padding-left: 0;
  }
}

@media (max-width: 500.5px) {
  .pagination {
    display: none;
  }
} */

.col-md-8,
.col-md-2 {
  padding: 0 !important;
}



.mini-search-container.small {
  top: 10px;
  right: 0;
  transform: scale(0.5);
  animation: mini-search-shrink 0.5s ease-in-out;
  max-width: 100%;
  z-index: 9999;
  margin: 0;
  width: 100%;
}

@keyframes mini-search-shrink {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0.9);
  }
}

.mini-search {
  /* width: 800px; */
  padding: 0;
}

/* .mini-search.small {
  top: 10px;
  left: 80%;
  animation: mini-search-shrink-6c930341 0.2s ease-in-out;
  z-index: 9999;
  margin: 0;
  position: absolute;
  width: 40%;
} */



/* .mini-search-container.position {
  position: fixed;
  top: 17px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  transition: transform 0.5s ease-in-out;
  width: 60%;
} */

.mini-search-container.smalls {
  position: fixed;
  top: 67px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  transition: transform 0.7s ease-in-out;
  width: 60%;
  height: 10px;
  opacity: 1;
}
</style>
